import * as React from "react";
import { Label } from "@interfaces/user";
import Icon from "@salesforce/design-system-react/components/icon";
import { FALLBACK_TAG_COLOR } from "@utils/constants";

const LabelItem = ({
	label,
	className = "",
}: {
	label: Label;
	className?: string;
}): JSX.Element => (
	<div className={`pc-label-item ${className}`} title={label?.name}>
		<Icon
			name="pc-label-access-small-icon"
			category="custom"
			size="xx-small"
			style={{ fill: label?.colour || FALLBACK_TAG_COLOR }}
		/>
		<p className="txt">{label.name}</p>
	</div>
);

export default LabelItem;
